import * as Yup from 'yup'
import { Range } from '../dosingLimits'

interface RangeMessages {
  required: string
  min: string
  max: string
  integer?: string
}

// An emptied input commits '' or null; both mean "not given", never NaN
const emptyToNull = (value: unknown, originalValue: unknown) =>
  originalValue === '' || originalValue === null ? null : value

export const boundedNumber = ({ min, max }: Range, messages: RangeMessages) => {
  const schema = Yup.number()
    .transform(emptyToNull)
    .nullable()
    .required(messages.required)
    .min(min, messages.min)
    .max(max, messages.max)

  return messages.integer ? schema.integer(messages.integer) : schema
}

// A schema that only applies while the sibling `flag` is on
export const whenEnabled = (flag: string, schema: Yup.Schema) =>
  Yup.mixed().when(flag, {
    is: true,
    then: () => schema,
    otherwise: (otherwise) => otherwise.notRequired()
  })
